/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { motion } from "framer-motion";
// material ui
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
// custom components
import UserListItem from "./UsersListItem";
import EmptyListing from "../../../shared-components/crud/listing/EmptyListing";

function UsersList(props) {
  // users from listing hook
  const { users } = props;
  // check if users is null
  if (!users) {
    return null;
  }
  // check if the listing returns any results
  if (users.length === 0) {
    return (
      <EmptyListing resource="users" />
    );
  }

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
      className="flex flex-col flex-auto w-full max-h-full"
    >
      {Object.keys(users).sort().map(key => (
        <div key={key} className="relative">
          <Typography
            color="text.secondary"
            className="px-32 py-4 text-14 font-medium"
          >
            {key}
          </Typography>
          <Divider />
          <List className="w-full m-0 p-0">
            {users[key].map(user => (
              <UserListItem key={user.id} user={user} />
            ))}
          </List>
        </div>
      ))}
    </motion.div>
  );
}

export default UsersList;
